import React from 'react'

function ConfirmRejectCompanyContent({ company, onBack, onNext }) {
  return (
    <>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content new-brp-modal">
          <div className="modal-header dome-d-flex dome-justify-center">
            <i className="fa-thin fa-circle-exclamation dome-color-red-alert" style={{ fontSize: 46 }}></i>
          </div>
          <div className="modal-body dome-d-flex dome-justify-center">
            <div className="dome-p1">{`Are you sure you want to reject ${company?.name}?`}</div>
          </div>
          <div className="modal-footer">
            <button
              className="dome-btn dome-btn-link dome-btn-link-cancel pull-left dome-color-med-grey"
              data-dismiss="modal"
              onClick={onBack}
            >
              cancel
            </button>
            <button type="button" className="dome-btn dome-btn-base dome-btn-red-stroke pull-right" onClick={onNext}>
              confirm
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConfirmRejectCompanyContent
